import { render } from "./multi-select.vue?vue&type=template&id=12e973a6&ts=true"
import script from "./multi-select.vue?vue&type=script&lang=ts"
export * from "./multi-select.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__